export enum TransactionSummarySteps {
  Records = 'transaction-records',
  ConfirmCancellation = `transaction-confirm-cancellation`,
  Cancelled = `transaction-cancelled`,
}
